import { Phone, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const StickyMobileCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-brand-navy/95 backdrop-blur-xl border-t border-white/10 px-4 py-3 safe-area-bottom" data-testid="sticky-mobile-cta">
      <div className="flex gap-3 max-w-lg mx-auto">
        <a
          href="tel:224-374-7400"
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl bg-white/10 border border-white/10 text-white font-medium text-sm hover:bg-white/15 transition-colors"
          data-testid="sticky-call-btn"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <Link
          to="/contact"
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl bg-brand-red text-white font-heading text-sm hover:bg-red-700 transition-colors"
          data-testid="sticky-quote-btn"
        >
          <FileText className="w-4 h-4" />
          Get My Quote
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
